import EventMgr from "@/utils/EventMgr";
import { useEffect, useState } from "react";


export const useData = <T>(key: string, defaultValue?: any): [T, (data: T) => void] => {
    const target = Symbol()
    const cacheData = UserDataCenter.getInstance().getDataByPacktId(key, target)
    const value = cacheData || defaultValue
   
    if(!cacheData && defaultValue){
        UserDataCenter.getInstance().setData(key, defaultValue, target)
    }

    const [data, setDataIn] = useState<T>(value)

    useEffect(() => {
        const data = UserDataCenter.getInstance().getDataByPacktId(key, target)
        if(data){
            setDataIn(data)
        }
        EventMgr.getInstance().addEventListener(key, (inData: T) => {
            UserDataCenter.getInstance().setData(key, inData, target)
            setDataIn(inData)
        }, target)
        return () => {
            EventMgr.getInstance().removeByTarget(target)
            UserDataCenter.getInstance().clearByPacktId(key, target)
        }
    }, [])

    const setData = (data: T) => {
        EventMgr.getInstance().dispatchEvent(key, data)
    }

    return [data, setData]
}

export class UserDataCenter {
    private cache: Map<string, Map<any, any>> = new Map<string, Map<any, any>>();

    private static instance: UserDataCenter;

    static getInstance(): UserDataCenter {
        if (!this.instance) {
            this.instance = new UserDataCenter()
        }
        return this.instance;
    }

    getDataByPacktId(packtId: string, target) {
        if (this.cache.has(packtId)) {
            const maps = this.cache.get(packtId);
            if (maps?.has(target)) {
                return maps.get(target)
            } else {
                if (maps?.size > 0) {
                    const values = maps.values();
                    return values.next().value;
                }
            }
        }
    }

    setData(packtId: string, data: any, target) {
        if (this.cache.has(packtId)) {
            let maps = this.cache.get(packtId);
            if (!maps) {
                maps = new Map<any, any>();
                this.cache.set(packtId, maps);
            }
            maps.set(target, data)
        } else {
            const maps = new Map<any, any>();
            maps.set(target, data)
            this.cache.set(packtId, maps);
        }
    }

    clearByPacktId(packetId: string, target: any) {
        if (this.cache.has(packetId)) {
            const maps = this.cache.get(packetId);
            if (maps?.has(target)) {
                maps.delete(target)
            }
            if (maps?.size === 0) {
                this.cache.delete(packetId)
            }
        }
    }
}